// util/scroller
define(
	'util/scroller',[
		'jquery',
		'easing',
		'pubsub'
	],

	function ( $ ) {

	    var Scroller;

	    return {
	        init: function(){
	            this._initSubscriptions();
	        },
	        _initSubscriptions: function(){
	            $.subscribe('/scroller/move', this._moveToElement);
	        },
	        _moveToElement: function(data){
	            var $element = $( data.element );
	            var threshold = data.threshold || 0;
	            var time = data.time || 350;
	            var easing = data.easing || 'easeInOutExpo';
	            var animate = data.animate == null ? true : data.animate;
	            var positionToMoveTo = $element.offset().top + threshold;
				if ( animate ) {
					$( 'html, body' ).stop().animate( { scrollTop: positionToMoveTo }, time, easing );
					return;
				}
				$('html, body').stop().scrollTop(positionToMoveTo);
			}
		};
	}
);


